import React from 'react';
import styled from 'styled-components';
import ChartContainer from '../components/chart/ChartContainer';

// Main chart area that will be passed as children to DashboardLayout
const ChartArea = styled.div`
  height: 100%;
  padding: 1rem;
  background-color: #111827;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  
  /* Make sure the chart has proper height */
  & > * {
    height: 100%;
    min-height: 400px;
  }
`;

interface DashboardProps {
  selectedSymbol?: string; // This will be injected by DashboardLayout
}

const Dashboard: React.FC<DashboardProps> = ({ selectedSymbol = 'BTC-PERP' }) => {
  return (
    <ChartArea>
      <ChartContainer selectedSymbol={selectedSymbol} />
    </ChartArea>
  );
};

export default Dashboard; 